import ErrorBoundary from './base';
import PageErrorMessage from './PageErrorMessage';

const PageErrorBoundary = props => <ErrorBoundary {...props} ErrorComponent={PageErrorMessage} />;

export default PageErrorBoundary;
